import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import RequestQuoteModalState from "@MasterBluePrint/Store/Components/RequestQuoteModal/RequestQuoteModalState";
import { Draft } from "immer";

const initialState: RequestQuoteModalState = {
    modalIsOpen: false,
    formIsLoaded: false,
    productNumber: "",
    paramThree: "",
    paramTwo: "",
    paramOne: "",
    formId: "",
};

const reducer = {
    "Components/RequestQuoteModal/CompleteSetIsOpen": (
        draft: Draft<RequestQuoteModalState>,
        action: {
            modalIsOpen: boolean;
            productNumber: string;
        },
    ) => {
        draft.modalIsOpen = action.modalIsOpen;
        draft.productNumber = action.productNumber;
    },
    "Components/RequestQuoteModal/CompleteSetFormIsLoaded": (
        draft: Draft<RequestQuoteModalState>,
        action: {
            formIsLoaded: boolean;
        },
    ) => {
        draft.formIsLoaded = action.formIsLoaded;
    },
    "Components/RequestQuoteModal/CompleteSetRequestQuoteModalParams": (
        draft: Draft<RequestQuoteModalState>,
        action: {
            paramThree: string;
            paramTwo: string;
            paramOne: string;
            formId: string;
        },
    ) => {
        draft.paramThree = action.paramThree;
        draft.paramTwo = action.paramTwo;
        draft.paramOne = action.paramOne;
        draft.formId = action.formId;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
